import { observer } from "mobx-react-lite";
import { Marker } from "react-map-gl/mapbox";
import { Loader2 } from "lucide-react";
import type { MapStore } from "@/components/Map/stores/MapStore";

interface ConnectionsCreatingMarkerProps {
	mapStore: MapStore<any>;
}

export const ConnectionsCreatingMarker = observer(({ mapStore }: ConnectionsCreatingMarkerProps) => {
	const { connectionsStore } = mapStore;
	const isCreating = connectionsStore.createApi.loading;
	const line = connectionsStore.previewStore.loadingLine;
	if (!isCreating || !line) {
		return null;
	}

	const midLng = (line.from[0] + line.to[0]) / 2;
	const midLat = (line.from[1] + line.to[1]) / 2;

	return (
		<Marker longitude={midLng} latitude={midLat}>
			<div className="rounded-full bg-white shadow-md border border-gray-200 p-1.5 inline-flex items-center justify-center">
				<Loader2 className="h-3.5 w-3.5 text-[#003BFF] animate-spin" />
			</div>
		</Marker>
	);
});
